
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.772 0.366117C17.2838 -0.122039 16.4924 -0.122039 16.0042 0.366117L1.27994 15.0904C1.0975 15.2728 0.975985 15.5073 0.932066 15.7615L0.436962 18.6275C0.289892 19.4788 1.03017 20.2191 1.88151 20.072L4.74747 19.5769C5.00171 19.533 5.23613 19.4115 5.41856 19.229L20.1429 4.50475C20.631 4.01659 20.631 3.22513 20.1429 2.73698L17.772 0.366117ZM15.4418 3.75697L16.8881 2.31066L18.1983 3.62086L16.752 5.06717L15.4418 3.75697ZM14.0276 5.17118L2.86237 16.3364L2.58877 17.9202L4.17258 17.6466L15.3378 6.48138L14.0276 5.17118Z","fill":"currentColor"}})])
          )
        }
      }
    